__turbopack_context__.v({
  "className": "lora_4761b0d1-module__1G4sXW__className",
  "variable": "lora_4761b0d1-module__1G4sXW__variable",
});
